// Hand-drawn SVG icons for brands the installed react-icons version (4.7.1)
// doesn't ship yet — mainly recent AI tools. Components mimic the react-icons
// signature: they accept `size` and render with `currentColor` so Chakra's
// `color`/`boxSize` props (and the admin picker's `size`) work the same way.

function baseProps(size, rest) {
  return {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...rest,
  };
}

// Claude / Claude Code — the Anthropic "spark": rays of alternating length
// radiating from the centre.
export function SiClaude({ size = "1em", ...rest }) {
  const rays = [
    [21.5, 12], [17.63, 15.25], [16.75, 20.23], [12, 18.5],
    [7.25, 20.23], [6.37, 15.25], [2.5, 12], [6.37, 8.75],
    [7.25, 3.77], [12, 5.5], [16.75, 3.77], [17.63, 8.75],
  ];
  return (
    <svg
      {...baseProps(size, rest)}
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    >
      {rays.map(([x, y], i) => (
        <line key={i} x1="12" y1="12" x2={x} y2={y} />
      ))}
    </svg>
  );
}

// Google Gemini — four-point concave sparkle.
export function SiGemini({ size = "1em", ...rest }) {
  return (
    <svg {...baseProps(size, rest)} fill="currentColor">
      <path d="M12 2 C12.5 7.5 16.5 11.5 22 12 C16.5 12.5 12.5 16.5 12 22 C11.5 16.5 7.5 12.5 2 12 C7.5 11.5 11.5 7.5 12 2 Z" />
    </svg>
  );
}

// GitHub Copilot — rounded head with two eyes (approximation).
export function SiCopilot({ size = "1em", ...rest }) {
  return (
    <svg {...baseProps(size, rest)} fill="currentColor">
      <path d="M12 3c-2 0-3.2.7-3.9 1.9C7.4 4.3 6.6 4 5.7 4 3.6 4 2 5.7 2 8v3.5C2 16 6.5 19 12 19s10-3 10-7.5V8c0-2.3-1.6-4-3.7-4-.9 0-1.7.3-2.4.9C15.2 3.7 14 3 12 3Zm-3.5 8.2c-.8 0-1.4-.8-1.4-1.9s.6-1.9 1.4-1.9 1.4.8 1.4 1.9-.6 1.9-1.4 1.9Zm7 0c-.8 0-1.4-.8-1.4-1.9s.6-1.9 1.4-1.9 1.4.8 1.4 1.9-.6 1.9-1.4 1.9Z" />
    </svg>
  );
}

// Cursor — the editor's angular cube mark (approximation).
export function SiCursor({ size = "1em", ...rest }) {
  return (
    <svg {...baseProps(size, rest)} fill="currentColor">
      <path d="M12 2 3 7v10l9 5 9-5V7l-9-5Zm0 2.3 6.5 3.6-6.5 3.6L5.5 7.9 12 4.3Zm-7 5.4 6 3.3v6.6l-6-3.3V9.7Zm14 0v6.6l-6 3.3v-6.6l6-3.3Z" />
    </svg>
  );
}
